import { reducerWithInitialState } from 'typescript-fsa-reducers'
import { Wallet, initWalletState, Card } from './state'
import { fetchWallet, FetchWalletPayload, addCard, deleteCard, resetLoadError, updateCard } from './actions'
import { getCardType, cardTypes } from 'app/utils/mapCardType'

const mapPayloadToCards = (payload: FetchWalletPayload): Array<Card> => {
    if (!payload.walletItem) {
        return []
    }

    return payload.walletItem.map(({ cardToken, primary, card, expired, card_holder }) => {
        const type = getCardType(card.code)
        if (!type) {
            throw `Invalid card type received, expected one of ${cardTypes.join(', ')}`
        }
        return {
            type,
            token: cardToken,
            primary,
            expired,
            lastFourDigits: card.last_four_digits,
            card_holder,
            expiry: {
                year: card.expire_year,
                month: card.expire_month
            }
        }
    })
}

export const reducer = reducerWithInitialState<Wallet>(initWalletState())
    // Handle fetch wallet actions
    .case(fetchWallet.async.started, (state) => ({ ...state, fetching: true }))
    .case(fetchWallet.async.failed, (state) => ({ ...state, fetching: false, error: true }))
    .case(fetchWallet.async.done, (state, { params, result }) => ({
        ...state,
        fetching: false,
        error: false,
        cards: mapPayloadToCards(result)
    }))

    // Handle add card actions
    .case(addCard.async.started, (state) => ({
        ...state,
        loading: true,
        error:  false
    }))
    .case(addCard.async.failed, (state, { error }) => ({
        ...state,
        loading: false,
        error
    }))
    .case(addCard.async.done, (state) => ({
        ...state,
        loading: false,
        error:  false,
    }))

    // Handle update card actions
    .case(updateCard.async.started, (state) => ({
        ...state,
        loading: true,
        error: false,
    }))
    .case(updateCard.async.failed, (state, { error }) => ({
        ...state,
        loading: false,
        error
    }))
    .case(updateCard.async.done, (state) => ({
        ...state,
        loading: false,
        error: false,
    }))

    // Handle delete card actions
    .case(deleteCard.async.started, (state, { cardToken }) => ({
        ...state,
        cards: state.cards?.map((card) =>
            cardToken !== card.token
                ? card
                : {
                      ...card,
                      loading: true
                  }
        )
    }))
    .case(deleteCard.async.failed, (state, { params: { cardToken } }) => ({
        ...state,
        cards: state.cards?.map((card) =>
            cardToken !== card.token
                ? card
                : {
                      ...card,
                      loading: false,
                      loadError: true
                  }
        )
    }))
    .case(deleteCard.async.done, (state, { params: { cardToken } }) => ({
        ...state,
        cards: state.cards?.filter((card) => cardToken !== card.token)
    }))

    // Reset card loading errors
    .case(resetLoadError, (state, cardToken) => ({
        ...state,
        cards: state.cards?.map((card) =>
            cardToken !== card.token
                ? card
                : {
                      ...card,
                      loadError: false
                  }
        )
    }))

    // Converts to a plain function
    .build()
